export const MetaService = {
  updateMeta(meta) {
    if (meta.title) {
      document.title = meta.title
    }
    
    this.updateTag('meta[name="description"]', meta.description)
    this.updateTag('link[rel="canonical"]', meta.canonical, 'href')
    this.updateTag('meta[property="og:title"]', meta.title)
    this.updateTag('meta[property="og:description"]', meta.description)
    this.updateTag('meta[property="og:url"]', meta.canonical)
  },

  updateTag(selector, content, attribute = 'content') {
    if (!content) return
    let el = document.querySelector(selector)
    if (!el) {
      if (selector.startsWith('meta')) {
        el = document.createElement('meta')
        const attr = selector.includes('name') ? 'name' : 'property'
        const match = selector.match(/["'](.*)["']/)
        if (match) el.setAttribute(attr, match[1])
      } else if (selector.startsWith('link')) {
        el = document.createElement('link')
        const match = selector.match(/rel=["'](.*)["']/)
        if (match) el.setAttribute('rel', match[1])
      }
      document.head.appendChild(el)
    }
    el.setAttribute(attribute, content)
  },

  injectJsonLd(viewName) {
    const existing = document.getElementById('scribe11-jsonld')
    if (existing) existing.remove()

    const script = document.createElement('script')
    script.id = 'scribe11-jsonld'
    script.type = 'application/ld+json'

    const common = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Scribe11",
      "url": "https://www.scribe11.com",
      "logo": "https://www.scribe11.com/logo.png",
      "accessibilityFeature": ["screenReaderControl", "fullKeyboardControl", "highContrastDisplay"]
    }

    let specific = null
    if (viewName === 'App') {
      specific = {
        "@context": "https://schema.org",
        "@type": "WebApplication",
        "name": "Scribe11 Editor",
        "operatingSystem": "Windows, macOS, Linux, iOS, Android",
        "applicationCategory": "BusinessApplication",
        "browserRequirements": "Requires HTML5, WebWorkers, WebLocks API",
        "accessibilityAPI": "ARIA",
        "accessibilityControl": ["fullKeyboardControl", "fullMouseControl", "fullVoiceControl"],
        "accessibilityHazard": "none"
      }
    }

    script.text = JSON.stringify({ "@graph": specific ? [common, specific] : [common] })
    document.head.appendChild(script)
  }
}
